module.exports = __webpack_public_path__ + "img/consultoria2_4-3.b6fdc905.jpg";